export default __webpack_public_path__ + "static/media/watermelon.7cb5fbaa.png";